import type { Project } from "@overmap-ai/common"

import type { RootSelector, RootState } from "../typings"

export const selectActiveProjectId: RootSelector<Project["uuid"] | null> = (state) => state.app.activeProjectId

export const selectActiveProject: RootSelector<Project | null> = (state: RootState) => {
	const activeProjectId = selectActiveProjectId(state)
	if (!activeProjectId) return null
	return state.projects.instances[activeProjectId] ?? null
}
